import React from 'react';

export default function Hero() {
  return (
    <div className="relative bg-white pt-16">
      <div className="relative max-w-7xl mx-auto py-16 sm:py-24 px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center text-center">
        <h1 
          className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-[#2A4365] animate-fade-in max-w-4xl bg-gradient-to-r from-[#2A4365] via-[#4A5568] to-[#C4A052] bg-clip-text text-transparent"
          style={{ fontFamily: 'Montserrat, sans-serif' }}
        >
          Estimation immobilière gratuite
        </h1>
        <p className="mt-4 sm:mt-6 text-base sm:text-lg lg:text-xl text-gray-700 max-w-3xl animate-fade-in" style={{ animationDelay: '0.2s' }}>
          Obtenez une estimation précise de votre bien immobilier en quelques minutes. Plus de 95% de nos estimations sont fiables à 5% près.
        </p>
      </div>
    </div>
  );
}